import React from 'react';
import styled from 'styled-components';
import AuthenticatedReferenceImage from './AuthenticatedReferenceImage';

const Wrap = styled.div`display: grid; gap: 0.85rem;`;
const Row = styled.div``;
const Label = styled.div`color: #334155; font-size: 0.82rem; font-weight: 800; margin-bottom: 0.25rem;`;
const Value = styled.div`color: #1e293b; line-height: 1.5; white-space: pre-wrap;`;
const Muted = styled.div`color: #64748b;`;
const References = styled.div`
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
  margin-top: 0.35rem;
`;
const ReferenceLink = styled.a`
  color: inherit;
  min-width: 0;
  text-decoration: none;
`;
const Filename = styled.div`
  color: #64748b;
  font-size: 0.75rem;
  margin-top: 0.35rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const formatAnswer = (field, answers) => {
  const value = answers?.[field.key];
  if (value == null || value === '' || (Array.isArray(value) && !value.length)) return null;
  if (Array.isArray(value)) return value.join(', ');
  return String(value);
};

export default function BoutiqueBriefView({ brief, offering, references, request }) {
  const resolvedBrief = brief ?? request?.boutique_brief;
  const resolvedOffering = offering ?? request?.offering;
  const resolvedReferences = references ?? request?.references ?? [];
  if (!resolvedBrief && !resolvedOffering && !resolvedReferences.length) return <Muted>No brief yet.</Muted>;
  const answers = resolvedBrief?.field_answers || {};
  const fields = resolvedOffering?.fields_schema || [];
  return (
    <Wrap>
      {resolvedOffering?.title ? (
        <Row>
          <Label>Offering</Label>
          <Value>{resolvedOffering.title}</Value>
        </Row>
      ) : null}
      <Row>
        <Label>Description</Label>
        <Value>{resolvedBrief?.description || '—'}</Value>
      </Row>
      {fields.map((field) => {
        const text = formatAnswer(field, answers);
        if (!text) return null;
        return (
          <Row key={field.key}>
            <Label>{field.label}</Label>
            <Value>{text}</Value>
          </Row>
        );
      })}
      <Row>
        <Label>References</Label>
        {resolvedReferences.length ? (
          <References>
            {resolvedReferences.map((reference) => (
              <ReferenceLink
                key={reference.id}
                href={reference.url || undefined}
                target={reference.url ? '_blank' : undefined}
                rel="noreferrer"
              >
                <AuthenticatedReferenceImage
                  url={reference.url}
                  reference={reference}
                  alt={reference.original_filename || 'Reference image'}
                  aspect="4 / 3"
                  radius="0.5rem"
                />
                <Filename>{reference.original_filename || 'Reference image'}</Filename>
              </ReferenceLink>
            ))}
          </References>
        ) : (
          <Muted>No reference images</Muted>
        )}
      </Row>
    </Wrap>
  );
}
